import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { apiClient } from '../services/api';

const Login = () => {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [rememberDevice, setRememberDevice] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const baseURL = apiClient?.defaults?.baseURL || '';
    const loginEndpoint = `${String(baseURL).replace(/\/$/, '')}/login`;
    console.info('[Login] Backend API base URL:', baseURL);
    console.info('[Login] Login endpoint:', loginEndpoint);
  }, []);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(formData.username, formData.password);

    if (result.success) {
      navigate('/dashboard');
      return;
    }

    setError(result.error);
    setLoading(false);
  };

  return (
    <div className="login-page">
      <div className="login-grain-texture" />
      <div className="login-blob login-blob-left" />
      <div className="login-blob login-blob-right" />

      <main className="login-main">
        <section className="login-branding">
          <div className="login-logo-row">
            <div className="login-logo-icon">
              <span className="material-symbols-outlined login-logo-symbol">architecture</span>
            </div>
            <span className="login-logo-text">No Man SOC</span>
          </div>

          <div className="login-copy">
            <h1>
              v1.0
            </h1>
          </div>

          <div className="login-features">
            <div className="login-feature-item">
              <div className="login-feature-check-wrap">
                <span className="material-symbols-outlined">check</span>
              </div>
              <span>AI-Powered Generate Report</span>
            </div>
            <div className="login-feature-item">
              <div className="login-feature-check-wrap">
                <span className="material-symbols-outlined">check</span>
              </div>
              <span>Multi-Platform Support</span>
            </div>
          </div>
        </section>

        <section className="login-panel-side">
          <div className="login-glass-panel">
            <div className="login-panel-head">
              <h2>No Man SOC</h2>
              <p>Enter your credentials to manage the workspace</p>
            </div>

            {error && <div className="login-error">{error}</div>}

            <form className="login-form" onSubmit={handleSubmit}>
              <div className="login-form-group">
                <label htmlFor="username">Username</label>
                <div className="login-input-wrap">
                  <span className="material-symbols-outlined login-input-icon">account_circle</span>
                  <input
                    id="username"
                    name="username"
                    type="text"
                    value={formData.username}
                    onChange={handleChange}
                    required
                    placeholder="cdo@architect.ai"
                  />
                </div>
              </div>

              <div className="login-form-group">
                <div className="login-password-header">
                  <label htmlFor="password">Password</label>
                </div>
                <div className="login-input-wrap">
                  <span className="material-symbols-outlined login-input-icon">lock</span>
                  <input
                    id="password"
                    name="password"
                    type={showPassword ? 'text' : 'password'}
                    value={formData.password}
                    onChange={handleChange}
                    required
                    placeholder="••••••••"
                  />
                  <button
                    type="button"
                    className="login-password-toggle"
                    onClick={() => setShowPassword((prev) => !prev)}
                    aria-label={showPassword ? 'Hide password' : 'Show password'}
                  >
                    <span className="material-symbols-outlined">
                      {showPassword ? 'visibility_off' : 'visibility'}
                    </span>
                  </button>
                </div>
              </div>

              <button className="login-submit-btn" type="submit" disabled={loading}>
                <span>{loading ? 'Signing in...' : 'Sign In'}</span>
                <span className="material-symbols-outlined">arrow_forward</span>
              </button>
            </form>

          </div>

          <div className="login-footer-meta">
            <p>© 2026 No Man SOC</p>
          </div>
        </section>
      </main>

      <div className="login-side-graphic" aria-hidden="true">
        <div className="login-side-graphic-media">
          <img
            src="https://lh3.googleusercontent.com/aida-public/AB6AXuC-z_XVE9nq_TvDwVyAkNTat29cypDC0qanD5HYliutXnkKqEv4n37Ua6X68sZ6Jk9KRkLb4us9UlRt-ITsTOUVU9l1pK15NOX6SdqpAf2TwYvDhw8PlT1dx0KN8KWh9iwfNPjwWQmqJ8kaBCD_OhJRQGXcFxGt1VAmZhVO8QYTw_hyvwjaU7a-EEO99w1HAayFDD0uBw5d3Swv6jfEpzx14AnzNtMHi51Jasy7Ck7bCbMlQXWZSiapd-wPNj6YbZFBO5HENuVVXBw"
            alt="High-tech server circuit board"
          />
          <div className="login-side-graphic-overlay" />
        </div>
      </div>
    </div>
  );
};

export default Login;
